module.exports = __webpack_public_path__ + "img/t6.c9b68124.png";